import script from "./WorksPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./WorksPicker.vue?vue&type=script&setup=true&lang=js"

import "./WorksPicker.vue?vue&type=style&index=0&id=347ab262&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-347ab262"]])

export default __exports__